@if (showPrompt() && !loading()) {
  <div class="mfa-prompt">
    <div class="mfa-prompt-accent"></div>
    <div class="mfa-prompt-container">
      <button
        (click)="onDismissLater()"
        class="mfa-prompt-close"
        title="Close notification"
        type="button"
        aria-label="Close">
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>
      <div class="mfa-prompt-header">
        <div class="mfa-prompt-icon-wrapper">
          <i nz-icon nzType="safety-certificate" nzTheme="fill" class="mfa-prompt-icon"></i>
        </div>
        <div class="mfa-prompt-title-section">
          <h4 class="mfa-prompt-title">Secure Your Account</h4>
          <span class="mfa-prompt-badge">Recommended</span>
        </div>
      </div>
      <div class="mfa-prompt-content">
        Add an extra layer of protection to your account. Multi-Factor Authentication (MFA) helps prevent unauthorized access even if your password is compromised.
      </div>
      <div class="mfa-prompt-actions">
        <div class="mfa-prompt-actions-row">
          <button type="button"
            nz-button
            nzType="default"
            class="mfa-prompt-button-secondary"
            (click)="onDismissLater()">
            Later
          </button>
          <button type="button"
            nz-button
            nzType="primary"
            class="mfa-prompt-button"
            (click)="navigateToSettings()">
            <i nz-icon nzType="safety-certificate" nzTheme="outline" style="margin-right: 6px;"></i>
            Setup Now
          </button>
        </div>
        <a
          class="mfa-prompt-link"
          (click)="onDismissPermanently()">
          Don't remind me again
        </a>
      </div>
    </div>
  </div>
}

